const chainIdToChainName = {
    137: "POLYGON",
    100: "GNOSIS CHAIN",
    42220: "CELO",
    25: "CRONOS"
}

export const chainNameToSymbol = {
    "POLYGON": "MATIC",
    "GNOSIS CHAIN": "xDAI",
    "CELO": "CELO",
    "CRONOS": "CRO",
}

export default chainIdToChainName